var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gestionCodigosListaVue',{attrs:{"arregloCodigos":_vm.codigoSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }